import { useState } from 'react'
import Loader from 'components/Common/Loader'
import { DragZoneWrapper, LoaderWrapper } from '../_styles'

const DragZone = props => {
  const { loading, onChange, hasError, empty, children, readOnly } = props

  const [dragging, setDragging] = useState(false)

  const makeDragEvent = value => event => {
    event.preventDefault()
    event.stopPropagation()
    setDragging(value)
  }

  const handleDrop = event => {
    const file = event?.dataTransfer.files?.[0]
    event.preventDefault()
    event.stopPropagation()
    setDragging(false)
    if (file && onChange) {
      onChange(file)
    }
  }

  return (
    <DragZoneWrapper
      onDrop={handleDrop}
      onDragOver={makeDragEvent(true)}
      onDragEnter={makeDragEvent(false)}
      onDragLeave={makeDragEvent(false)}
      dragging={dragging}
      hasError={hasError}
      empty={empty}
      readOnly={readOnly}
    >
      {loading ? (
        <LoaderWrapper>
          <Loader color='#fff' size='16px' />
        </LoaderWrapper>
      ) : (
        children
      )}
    </DragZoneWrapper>
  )
}

export default DragZone
